import React, { useEffect, useState } from "react";
import { Form, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import '../../assets/css/productCardNewDesign.css'

const ProductCardNewDesign = (props) => {

  // New Price Offer Popup Handlers
  const handlePriceOfferClick = (offerData) => {
    props.onReject(offerData);
    // setShowPriceOfferPopup(true);
  }
  const handlePriceUpdateReq = (status) => {
    if (status === "Yes") {
      props.handleUpdatePriceReq(props.lead, props.productId, props.newPrice, "V_ACTIVE", props.url);
    } else {
      props.handleUpdatePriceReq(props.lead, props.productId, props.newPrice, "V_REJECT", props.url);
    }
  }
  return (
    <>
      <tr key={props.index} className="transfer-row">

        {/* Checkbox */}
        <td className="product-checkbox">
          <input
            type="checkbox"
            checked={props?.selectedIds.includes(props.lead)}
            onChange={(e) =>
              props.onSelectItem(props.lead, e.target.checked)
            }
          />
        </td>

        {/* Product Details */}
        <td className="product-details-td">
          <div className="product-details-wrapper">

            <div className="product-icon">
              {/* <span>▣</span> */}
              <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 invent_table_pro_img mx-1" />
            </div>

            <div className="product-info">
              <div className="product-name">
                {props.url ? 
                  <a 
                    href={`/productDetConf/${props.productId}?url=${props.url}`} 
                    target="_blank">
                    {props.productName}
                  </a>
                  : <a 
                    href={`/productDetail/${props.productId}/approv`}
                    target="_blank">
                    {props.productName}
                  </a>
                }
              </div>

              <div className="product-sku">
                SKU: {props.SKU}
              </div>

              {props.comb && <div className="product-category">
                {props.comb}
              </div>}
            </div>

          </div>
        </td>

        {/* Transfer Price */}
        <td className="transfer-price-td">
          <div className="price-box">

            <div className="price-current">
              <span className="price-label">
                CURRENT PRICE
              </span>

              <span className="price-value">
                ₹ {props.currentPrice || 'N/A'}
              </span>
            </div>

            <div className="price-arrow">
              <span>to</span>
            </div>

            <div className="price-new">
              <span className="price-label">
                NEW PRICE
              </span>

              <span className="price-value">
                ₹ {props.newPrice}
              </span>
            </div>

          </div>
        </td>

        {/* Requested Date */}
        <td className="requested-date-td">
          {props.updatedon}
        </td>

        {/* Actions */}
        <td className="actions-td">

          <button
            type="button"
            className="reject-btn"
            onClick={() => 
              handlePriceOfferClick({
                vPriceReqId: props.lead,
                productId: props.productId,
                productName: props.productName,
                currentPrice: props.currentPrice,
                newPrice: props.newPrice,
                taxClass: props.taxClass,
                comb: props.comb,
                url: props.url,
                // stock: props?.quantity
              })}
          >
            Reject
          </button>

          <button
            type="button"
            className="accept-btn"
            onClick={() => handlePriceUpdateReq("Yes")}
          >
            Accept
            <span className="accept-check">✓</span>
          </button>

        </td>

      </tr>
    </>
  )
}

export default ProductCardNewDesign;